import { render } from "./MatrizesUploadModal.vue?vue&type=template&id=1139bcc8"
import script from "./MatrizesUploadModal.vue?vue&type=script&lang=js"
export * from "./MatrizesUploadModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__